export default __webpack_public_path__ + "static/media/black_unicorn.6d85e7c1.png";